<template>
    <span class="subtext">
        <span class="vs" v-if="label">vs {{ label }}</span>
        <diff-indicator-number :number="primary" :filter="primaryFilter"/>
        <diff-indicator-number
            v-if="typeof secondary !== 'undefined'"
            :number="secondary"
            :filter="secondaryFilter"
            prepend="("
            append=")"
        />
    </span>
</template>

<script>
import DiffIndicatorNumber from 'src/components/DiffIndicatorNumber';
export default {
    props: [
        'label',
        'primary',
        'secondary',
        'primaryFilter',
        'secondaryFilter',
    ],
    components: {
        DiffIndicatorNumber,
    },
};
</script>

